// extracted by mini-css-extract-plugin
export default {"button":"button-d426d7f5","active":"active-a23c35e5","button_wrapper":"button_wrapper-d90a11d5","buttonWrapper":"button_wrapper-d90a11d5","spinner":"spinner-f8f6637e"};